import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getThemeColor,
  getUserDetailsFromReducer,
  getWidgetsFromReducer,
  setWidgets,
  addWidget,
  editWidget,
  deleteWidget,
  updateUserDetailsInReducer,
} from "Store/reducers/Auth/AuthSlice";
import { generateUUID } from "Utility/Common/Methods";
import { updateAccountDetails } from "Sdk/Actions";
import {
  cardWidgetSample,
  discriptionWidgetSample,
  imageWidgetSample,
  titleWidgetSample,
} from "Utility/Contants/WidgetsContants";
import { ActionBar } from "./ActionBar";
import { DigitalProfile } from "./DigitalProfile";
import { message } from "antd";

const DigitalProfileContainer = () => {
  const themeColorString = useSelector(getThemeColor);
  const userDetails = useSelector(getUserDetailsFromReducer);
  const widgets = useSelector(getWidgetsFromReducer);
  const dispatch = useDispatch();
  let themeColor;

  const [uuid1, setUuid1] = useState();
  const [uuid2, setUuid2] = useState();

  useEffect(() => {
    let widget = userDetails?.widgets;
    if (widget && widget?.length > 0) {
      try {
        let data = JSON.parse(widget);
        dispatch(setWidgets(data));
      } catch (error) {
        console.log(error);
      }
    } else {
      dispatch(setWidgets([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails]);

  useEffect(() => {
    setTimeout(() => {
      setUuid2(uuid1);
    }, 3000);
  }, [uuid1]);

  useEffect(() => {
    if (uuid2) handleSaveWidgets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid2]);

  const handleAddWidget = (type) => {
    let obj = {};
    switch (type) {
      case "title":
        obj = { ...titleWidgetSample };
        break;
      case "discription":
        obj = { ...discriptionWidgetSample };
        break;
      case "image":
        obj = { ...imageWidgetSample };
        break;
      case "card":
        obj = { ...cardWidgetSample };
        break;
      default:
        return null;
    }
    obj.isEditing = true;
    obj.id = generateUUID();
    dispatch(addWidget(obj));
    setUuid1(generateUUID());
  };

  const handleEditWidget = ({ index, key, value }) => {
    dispatch(editWidget({ index, key, value }));
    setUuid1(generateUUID());
  };

  const handleDeleteWidget = (index) => {
    dispatch(deleteWidget(index));
    setUuid1(generateUUID());
  };

  const handleSaveWidgets = async () => {
    if (uuid1 !== uuid2) {
      return;
    }
    try {
      let data = widgets.map(({ isEditing, ...rest }) => rest);
      let widgetStringified = JSON.stringify(data);
      const userData = {
        username: userDetails?.username,
        widgets: widgetStringified,
      };
      await updateAccountDetails(userData);
      dispatch(updateUserDetailsInReducer({ widgets: widgetStringified }));
      message.success("Changes saved! Publish to go live.");
    } catch (error) {
      console.log(error);
    }
  };

  try {
    themeColor = JSON.parse(themeColorString);
  } catch (error) {
    console.error("Failed to parse themeColor:", themeColorString, error);
    // Fallback to default theme
    themeColor = {
      background: "#E6E6E6",
      text: "#333C4D",
      btnBg: "#333C4D",
      btnText: "#ffffff",
    };
  }

  return (
    <div className="flex flex-col lg:flex-row min-h-screen p-2 sm:p-4 md:p-6 lg:p-8 xl:p-10 gap-4 lg:gap-6">
      {/* Main Content Area */}
      <div className="flex-1 lg:flex-[0_0_75%] xl:flex-[0_0_80%]">
        <figure className="mx-auto relative z-1 max-w-full rounded-b-lg rounded-lg">
          {/* Browser Header */}
          <div className="relative flex items-center bg-gray-800 rounded-t-lg py-2 px-4 sm:px-8 md:px-16 lg:px-24 dark:bg-neutral-700">
            <div className="flex gap-x-1 absolute top-2/4 start-4 -translate-y-1">
              <span className="size-2 bg-gray-600 rounded-full dark:bg-neutral-600"></span>
              <span className="size-2 bg-gray-600 rounded-full dark:bg-neutral-600"></span>
              <span className="size-2 bg-gray-600 rounded-full dark:bg-neutral-600"></span>
            </div>
            <div className="flex justify-center items-center size-full bg-gray-700 text-[.25rem] sm:text-[.375rem] md:text-[.5rem] text-gray-400 rounded-sm dark:bg-neutral-600 dark:text-neutral-400">
              inprofile.co/{userDetails?.username}
            </div>
          </div>

          {/* Profile Content */}
          <div className="overflow-auto h-[70vh] sm:h-[75vh] md:h-[80vh] lg:h-[85vh] rounded-b-lg">
            <DigitalProfile
              widgets={widgets}
              username={userDetails?.username}
              onWidgetEdit={handleEditWidget}
              onWidgetDelete={handleDeleteWidget}
              themeColor={themeColor}
            />
          </div>
        </figure>
      </div>

      {/* Action Bar */}
      <div className="lg:flex-[0_0_25%] xl:flex-[0_0_20%] lg:min-w-[280px] lg:max-w-[320px]">
        <ActionBar onAddCard={handleAddWidget} />
      </div>
    </div>
  );
};

export default DigitalProfileContainer;
